import { Link } from "react-router-dom";

const LEGAL_DOCUMENTS = [
  {
    to: "/terms",
    eyebrow: "Rules",
    title: "Terms of Service",
    copy: "Platform rules, account responsibilities, acceptable use, and liability boundaries for MyTradeFinder."
  },
  {
    to: "/privacy",
    eyebrow: "Data",
    title: "Privacy Policy",
    copy: "What personal data is processed, why it is processed, how it is shared, and what rights users may have."
  },
  {
    to: "/cookies",
    eyebrow: "Storage",
    title: "Cookie Policy",
    copy: "Current use of the session cookie and functional local storage, with room to expand later if tracking changes."
  }
];

export default function LegalOverviewView() {
  return (
    <div className="account-shell">
      <div className="account-page-header">
        <div className="account-breadcrumb">
          <span>Legal</span>
        </div>
        <div>
          <h1 className="account-page-title">Legal</h1>
          <p className="account-copy">
            Central access point for MyTradeFinder&apos;s legal documents, privacy disclosures, and cookie information.
          </p>
        </div>
      </div>

      <section className="account-folder-grid" aria-label="Legal documents">
        {LEGAL_DOCUMENTS.map((document) => (
          <Link key={document.to} to={document.to} className="account-folder-card account-folder-card--compact">
            <span className="account-folder-card__eyebrow">{document.eyebrow}</span>
            <strong className="account-folder-card__title">{document.title}</strong>
            <span className="account-folder-card__copy">{document.copy}</span>
          </Link>
        ))}
      </section>
    </div>
  );
}